import * as React from "react";
import {
  useNavigate,
  useLocation,
} from "react-router-dom";
import {
  Menu, MenuItem, Button
} from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';


const MainMenu = ({pages}) => {
  const navigate = useNavigate();
  const location = useLocation();


  return pages.map((page) => {
    if(page.menu) {
      return (
        <DropdownMenu key={page.link} page={page}/>
      );
    } else
      return (
        <Button variant="text" key={page.link}
                color={location.pathname!=page.link?'primary':'secondary'}
                onClick={()=>navigate(page.link)} >
          {page.label}
        </Button>
      );
  });
};

const DropdownMenu = ({page}) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const location = useLocation();
  const navigate = useNavigate();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <React.Fragment>
      <Button variant="text"
              color={!location.pathname.startsWith(page.link)?
                     'primary':'secondary'}
              onClick={handleClick}
              aria-controls={open ? 'account-menu' : undefined}
              aria-haspopup="true"
              aria-expanded={open ? 'true' : undefined}
              endIcon={<KeyboardArrowDownIcon fontSize="small" />}
      >
        {page.label}
      </Button>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        { page.menu.map((menuItem)=>
                        menuItem.onClick?(
                          <MenuItem key={menuItem.key}
                                    onClick={menuItem.onClick}>
                            {menuItem.label}
                          </MenuItem>
                        ):(
                          <MenuItem key={menuItem.link}
                                    onClick={()=>navigate(menuItem.link)}>
                            {menuItem.label}
                          </MenuItem>)
                       )}
      </Menu>
    </React.Fragment>
  );
};

export default MainMenu;
